import React from "react";

export const applyTextTransformations = (
  label: string,
  termsToNotTranslate: string[] = [],
  termsApplyBold: string[] = []
): string | React.JSX.Element[] => {
  if (termsToNotTranslate.length === 0 && termsApplyBold.length === 0) return label;

  // Combine all terms into one pattern
  const allTerms = [...new Set([...termsToNotTranslate, ...termsApplyBold])];
  const pattern = new RegExp(`\\b(${allTerms.join('|')})\\b`, 'gi');

  const parts = label?.split(pattern).filter(part => part) || [];

  return parts.map((part, index) => {
    const isNoTranslate = termsToNotTranslate.some(term =>
      part.toLowerCase() === term.toLowerCase()
    );
    const isBold = termsApplyBold.some(term =>
      part.toLowerCase() === term.toLowerCase()
    );

    if (isNoTranslate && isBold) {
      return (
        <span key={index} className="notranslate" style={{ fontWeight: 700 }}>
          {part}
        </span>
      );
    } else if (isNoTranslate) {
      return <span key={index} className="notranslate">{part}</span>;
    } else if (isBold) {
      return <span key={index} style={{ fontWeight: 700 }}>{part}</span>;
    } else {
      return <span key={index}>{part}</span>;
    }
  });
};